import { axiosRubyClient } from '@/util/axios/axiosClient';

// Read-only Actions Log feed over shift_events (internal/tenant-admin only).
// Backed by GET /api/admin/shift_events (+ /filters). See GRAVY-10196.

export type ShiftEventActorType = 'ops' | 'worker' | 'system';

export interface ShiftEventActor {
  type: ShiftEventActorType;
  id?: number | null;
  name?: string | null;
}

export interface ShiftEventShift {
  id: number;
  start_at: string | null;
  end_at: string | null;
  job_id: number | null;
  client_name: string | null;
}

export interface ShiftEventEntry {
  id: number;
  event_id: string;
  event_type: string;
  triggered_by: string;
  created_at: string | null;
  description: string;
  actor: ShiftEventActor;
  shift: ShiftEventShift | null;
  json_data: Record<string, unknown> | null;
}

export interface Pagination {
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
}

export interface ShiftEventsResponse {
  success: boolean;
  data: ShiftEventEntry[];
  pagination: Pagination;
}

export interface ShiftEventFilterOption {
  id: number;
  name: string;
}

export interface ShiftEventFiltersResponse {
  success: boolean;
  data: {
    users: ShiftEventFilterOption[];
    clients: ShiftEventFilterOption[];
  };
}

export interface ShiftEventsParams {
  page?: number;
  per_page?: number;
  search?: string;
  user_id?: number | string;
  client_id?: number | string;
  date?: string;
}

export const fetchShiftEvents = async (
  params: ShiftEventsParams,
): Promise<ShiftEventsResponse> => {
  const response = await axiosRubyClient.get('/api/admin/shift_events', {
    params,
  });
  return response.data;
};

export const fetchShiftEventFilters =
  async (): Promise<ShiftEventFiltersResponse> => {
    const response = await axiosRubyClient.get(
      '/api/admin/shift_events/filters',
    );
    return response.data;
  };
